import React, { useState } from "react";
import logo from "../../assets/dawailogo.png";
import './Header.css'
import HeaderRight from "../HeaderRight/HeaderRight";
import { Link } from "react-router-dom";

const Header = () => {
  const [cartItems, setCartItems] = useState([]);
  const addToCart = (item) => {
    setCartItems((prevItems) => [...prevItems, item]);
  };
  return (
    <div className="Header">
      <div className="Header-left">
      <Link to="/"> <img src={logo} alt="logo" /></Link>
     
        <input
          id="MedicineSearch"
          class="search_input"
          type="search"
          placeholder="Search Medicines..."
          autocomplete="off"
        ></input>
      </div>
      <div className="Header-right">
        <HeaderRight cartItems={cartItems} />
      </div>

    </div>

  );
};

export default Header;
